import { useCallback, useEffect, useState } from "react";

/**
 * Subscribe to coach-published live mode state (interval timer, match
 * scoreboard) for one exercise. Asks the server for the cached state on join.
 *
 * @returns {{ interval: object|null, match: object|null, publish: (kind: string, state: object) => void }}
 */
export function useLiveModeSync({ socket, tsId, teId, enabled = true }) {
  const [byKind, setByKind] = useState({});

  useEffect(() => {
    setByKind({});
  }, [teId]);

  useEffect(() => {
    if (!enabled || !socket || !tsId || !teId) return undefined;
    const onSync = (payload) => {
      if (!payload || String(payload.te_id) !== String(teId)) return;
      if (payload.kind !== "interval" && payload.kind !== "match") return;
      setByKind((prev) => ({
        ...prev,
        [payload.kind]: {
          state: payload.state,
          receivedAt: Date.now(),
          ageMs: Number(payload.age_ms) || 0,
        },
      }));
    };
    socket.on("liveModeSync", onSync);
    socket.emit("liveModeSyncRequest", { ts_id: tsId, te_id: teId });
    return () => socket.off("liveModeSync", onSync);
  }, [socket, tsId, teId, enabled]);

  const publish = useCallback(
    (kind, state) => {
      if (!socket || !tsId || !teId) return;
      socket.emit("liveModeSync", { ts_id: tsId, te_id: teId, kind, state });
    },
    [socket, tsId, teId]
  );

  return {
    interval: byKind.interval || null,
    match: byKind.match || null,
    publish,
  };
}

export default useLiveModeSync;
